export const colors = {
  dark: "#181818",
  darkLight: "#242424",
  green: "#b8ff2e",
  grey: "#757580",
  white: "#f2f2f2",
  secondaryDark: "#303032",
  red: "red",
  resultsRed: "#D07149",
  resultsGreen: "#1CE39F",
  gold: "#ffcf40",
  bronze: "#CD7F32",
  silver: "#bfbfbf",
};

// Side fade: solid in the middle 1100px, fading to fully transparent at the screen edges.
export const sideFadeMask = `linear-gradient(
  90deg,
  transparent 0,
  #000 calc(50% - 550px),
  #000 calc(50% + 550px),
  transparent 100%
)`;

export const breakpointsCustom = {
  mobile: 480,
  sm: 576,
  md: 768,
  lg: 992,
  max: 1320,
};
